// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1tKmE","badges":"styles_badges__Zc6cN"};